import { AxiosResponse } from 'axios'

import { IFaqUrlResponse } from 'interfaces/common'
import {
  IGoogleLocationIdRequestDTO,
  IGooglePlaceIdResponseDTO,
} from 'interfaces/receipt'
import {
  IGuestEstablishmentRequest,
  IGuestEstablishmentResponse,
  IGuestContactFormRequest,
  IGuestUnsubscribeRequest,
} from 'interfaces/payment'
import {
  IRatingUpdateRequestDTO,
  ITabsRatingRequest,
  ITabsResponse,
} from '../interfaces/tabs'
// eslint-disable-next-line import/no-cycle
import httpClient from './base-service'
import { IApiSuccessResponse } from '../interfaces/api-success-response'

const endPointBaseURL = `/Guest`

const rateExperience = async (
  requestBody: ITabsRatingRequest
): Promise<AxiosResponse<IApiSuccessResponse<ITabsResponse>>> =>
  httpClient.post<IApiSuccessResponse<ITabsResponse>>(
    `${endPointBaseURL}/save-rate-experience`,
    requestBody
  )

const updateRateExperience = async (
  requestBody: IRatingUpdateRequestDTO
): Promise<AxiosResponse<IApiSuccessResponse<string>>> =>
  httpClient.post<IApiSuccessResponse<string>>(
    `${endPointBaseURL}/update-rate-experience`,
    requestBody
  )

const ContactForm = async (
  requestBody: IGuestContactFormRequest
): Promise<AxiosResponse<IApiSuccessResponse<string>>> =>
  httpClient.post<IApiSuccessResponse<string>>(
    `/GuestMarketing/contact-form`,
    requestBody,
    {
      hideLoader: false,
    }
  )

const GuestUnsubscribe = async (
  requestBody: IGuestUnsubscribeRequest
): Promise<AxiosResponse<IApiSuccessResponse<string>>> =>
  httpClient.post<IApiSuccessResponse<string>>(
    `${endPointBaseURL}/unsubscribe`,
    requestBody,
    {
      hideLoader: false,
    }
  )

const getFaqUrl = async (): Promise<
  AxiosResponse<IApiSuccessResponse<IFaqUrlResponse>>
> =>
  httpClient.get<IApiSuccessResponse<IFaqUrlResponse>>(`/Common/get-faq-url`, {
    hideLoader: true,
  })

const GetPlaceIdLocationName = async (
  requestBody: IGoogleLocationIdRequestDTO
): Promise<AxiosResponse<IApiSuccessResponse<IGooglePlaceIdResponseDTO>>> =>
  httpClient.post<IApiSuccessResponse<IGooglePlaceIdResponseDTO>>(
    `${endPointBaseURL}/get-google-location-name-by-placeid`,
    requestBody
  )

const GetGuestEst = async (
  requestBody: IGuestEstablishmentRequest
): Promise<AxiosResponse<IApiSuccessResponse<IGuestEstablishmentResponse>>> =>
  httpClient.post<IApiSuccessResponse<IGuestEstablishmentResponse>>(
    `${endPointBaseURL}/get-guest-establishment`,
    requestBody
  )

const UpdateGuestEstablishmentOptIn = async (
  requestBody: IGuestEstablishmentRequest
): Promise<AxiosResponse<IApiSuccessResponse<string>>> =>
  httpClient.post<IApiSuccessResponse<string>>(
    `${endPointBaseURL}/update-guest-opt-in`,
    requestBody
  )

export default {
  rateExperience,
  getFaqUrl,
  GetPlaceIdLocationName,
  updateRateExperience,
  ContactForm,
  GuestUnsubscribe,
  GetGuestEst,
  UpdateGuestEstablishmentOptIn,
}
